import { render } from "./InstructorFilter.vue?vue&type=template&id=476df798&scoped=true"
import script from "./InstructorFilter.vue?vue&type=script&lang=js"
export * from "./InstructorFilter.vue?vue&type=script&lang=js"

import "./InstructorFilter.vue?vue&type=style&index=0&id=476df798&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476df798"]])

export default __exports__